import classNames from "classnames";
import React from "react";

export type ContainerProps = {
    children: React.ReactNode;
    className?: string;
    as?: React.ElementType;
    ref?: React.Ref<HTMLDivElement> | React.Ref<React.ElementType>;
};

const Container = ({
    children,
    className,
    as: Component = "div",
    ...props
}: ContainerProps) => {
    const containerClass = "tw:w-full";

    return (
        <Component
            className={classNames(containerClass, className)}
            {...props}
        >
            {children}
        </Component>
    );
};

export { Container };
